import React from "react";
import { useRecordContext, useRedirect } from "react-admin";
import Button from "@mui/material/Button";
import { useTranslate } from "react-admin";

const ChatButton = ({ userDoctorType, id, doctorId }) => {
  const redirect = useRedirect();
  const translate = useTranslate();
  if (!id) return null;
  return (
      <Button
          variant="contained"
          color="primary"
          style={{
              whiteSpace: "nowrap"
          }}
          className="chat-button"
          onClick={() => redirect(`/chat/${id}/${userDoctorType}?doctorId=${doctorId}`)}
      >
          <span className="chat-button-text">{translate("buttons.chat")}</span>
          <span className="chat-button-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                  viewBox="0 0 24 24"
                                                  fill="none">
              <path stroke="currentColor" strokeWidth="1.5"
                    d="M21 10.5c.535.75.713 2 0 3-1.366 1.915-4.31 5.5-9 5.5s-7.634-3.585-9-5.5c-.713-1-.535-2.25 0-3C4.366 8.584 7.31 5 12 5s7.634 3.584 9 5.5Z"></path>
              <path stroke="currentColor" strokeWidth="1.5"
                    d="M15 12a3 3 0 1 0-6 0 3 3 0 0 0 6 0Z"></path>
          </svg></span>
      </Button>
  );
};

export default ChatButton;
